import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import React, { FC } from 'react';
import { Text, TranslationFunction } from '../../../components/blocks/localization';
import { PoReviewRowStatus } from '../poReviewValidation';

export type StatusFilterOption = {
    status: PoReviewRowStatus;
    labelKey: string;
};

export const STATUS_FILTER_OPTIONS: StatusFilterOption[] = [
    { status: PoReviewRowStatus.ERROR, labelKey: 'statusFilterError-option' },
    { status: PoReviewRowStatus.WARNING, labelKey: 'statusFilterWarning-option' },
    { status: PoReviewRowStatus.OK, labelKey: 'statusFilterOk-option' },
];

const hideSelectedValues = () => '';

export type PoReviewStatusFilterProps = {
    t: TranslationFunction;
    selectedStatuses: PoReviewRowStatus[];
    onChange: (statuses: PoReviewRowStatus[]) => void;
    lineCount: number;
    dataTestId: string;
};

export const PoReviewStatusFilter: FC<PoReviewStatusFilterProps> = ({
    t,
    selectedStatuses,
    onChange,
    lineCount,
    dataTestId,
}) => (
    <Row spacing={'small'} alignmentVertical={'center'}>
        <Select
            value={selectedStatuses}
            onChange={onChange}
            placeholder={t('statusFilter-label')}
            size={'medium'}
            valueLabel={hideSelectedValues}
            data-testid={`${dataTestId}.statusFilter`}
        >
            {STATUS_FILTER_OPTIONS.map(({ status, labelKey }) => (
                <SelectOption key={status} value={status} label={t(labelKey)} />
            ))}
        </Select>
        <Text type={'b200'}>{t('lineCount-text', { count: lineCount })}</Text>
    </Row>
);
